import { useApiClientStore } from '../stores/useApiClientStore';
import { Availability, TenantConfigResponse } from '../types/tenant';
import { ApiResponseRaw, RequestTypeShort } from '../types';

export async function fetchTenantConfig(): Promise<TenantConfigResponse> {
  const apiClientStore = useApiClientStore();
  const api = apiClientStore.client;

  if (!api) {
    throw new Error('API client not initialised (tenant not set)');
  }
  return api.get<TenantConfigResponse>('/patient-portal/configuration');
}

export async function fetchRequestFormStatusApi(
  requestType: RequestTypeShort,
): Promise<ApiResponseRaw<Availability>> {
  const apiClientStore = useApiClientStore();
  const api = apiClientStore.client;

  if (!api) {
    throw new Error('API client not initialised (tenant not set)');
  }
  return api.getRaw<Availability>(`/patient-portal/request-availability/${requestType}`);
}
